



























import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { ExchangeTradesModule } from '@/store/modules/exchangeTrades';
import Trade from './Trade.vue';
import { Exchange } from '@/types/trade';

interface FilterItem {
  text: string;
  value: Exchange;
  color: string;
  chipText: string;
}

@Component({
  name: 'TimeAndSales',
  components: {
    Trade,
  },
})
export default class TimeAndSales extends Vue {
  private items: FilterItem[] = [
    {
      text: 'Bitfinex',
      value: Exchange.Bitfinex,
      color: 'green',
      chipText: 'finex',
    },
    {
      text: 'bitFlyer',
      value: Exchange.Bitflyer,
      color: 'indigo',
      chipText: 'Flyer',
    },
    { text: 'BitMEX', value: Exchange.Bitmex, color: 'red', chipText: 'MEX' },
  ];
  get marketTimeAndSales() {
    return ExchangeTradesModule.marketTimeAndSales;
  }
  get exchangeFilter() {
    return ExchangeTradesModule.exchangeFilter;
  }
  private setFilter(filter: Exchange[]) {
    ExchangeTradesModule.setFilter(filter);
  }
  private remove(item: FilterItem) {
    const tmpExchangeFilter = [...this.exchangeFilter];
    tmpExchangeFilter.splice(tmpExchangeFilter.indexOf(item.value), 1);
    ExchangeTradesModule.setFilter(tmpExchangeFilter);
  }
}
